import { Box, Link } from "@mui/material";
import { yellow } from "@mui/material/colors";
import PropTypes from "prop-types";
import React from "react";
import { DOCS } from "../../utils/constants";
import { isOrgActive, isSandbox, setSandbox } from "../../utils/io";
import theme from "../../utils/theme";
import SideNavbar from "./Navbar";

export const CONTENT_ROOT_ID = "content-root";

function MainLayout(props) {
  const { children } = props;

  const switchSandbox = (isOn) => {
    setSandbox(isOn);
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
      }}
    >
      <SideNavbar />
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
        id={CONTENT_ROOT_ID}
      >
        {isSandbox() && (
          <Box
            sx={{
              textAlign: "center",
              background: yellow[700],
              padding: "7px 0",
              color: theme.colors.darkGrey,
              fontSize: theme.fontSize.medium,
              width: "100%",
            }}
          >
            {isOrgActive() ? (
              <>
                You are in sandbox mode, click{" "}
                <Box
                  component="span"
                  onClick={() => switchSandbox(false)}
                  aria-hidden="true"
                  sx={{
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  here
                </Box>{" "}
                to return to production.{" "}
                <Link
                  href={DOCS.SANDBOX_MODE.url}
                  target="_blank"
                  rel="noreferrer"
                  color={theme.colors.stelBlue}
                >
                  Learn more.
                </Link>
              </>
            ) : (
              <>
                You are in sandbox mode, contact sales@stel.life to get started
                in production.{" "}
                <Link
                  href={DOCS.SANDBOX_MODE.url}
                  target="_blank"
                  rel="noreferrer"
                  color={theme.colors.stelBlue}
                >
                  Learn more.
                </Link>
              </>
            )}
          </Box>
        )}

        {children}
      </Box>
    </Box>
  );
}

const defaultProps = {};
MainLayout.defaultProps = defaultProps;
MainLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default MainLayout;
